<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="taskType" label="任务类型" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType==1">抖音视频</span>
                        <span v-if="scope.row.taskType==2">抖音评论</span>
                        <span v-if="scope.row.taskType==3">小红书</span>
                        <span v-if="scope.row.taskType==4">应用好评</span>
                        <span v-if="scope.row.taskType==5">快手视频</span>
                        <span v-if="scope.row.taskType==6">快手评论</span>
                        <span v-if="scope.row.taskType==7">小红书评论</span>
                        <span v-if="scope.row.taskType==8">抖音图文</span>
                    </template>
                </el-table-column>
                <el-table-column prop="targetUrl" label="目标链接" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="copyTargetUrl(scope.row.targetUrl)" v-if="scope.row.targetUrl">点击跳转</el-button>
                        <!-- <span @click="copyTargetUrl(scope.row.targetUrl)" class="cursor">{{ getHrefUrl(scope.row.targetUrl) }}</span> -->
                    </template>
                </el-table-column>
                
                <el-table-column prop="userId" label="接收任务用户" align="center" width="120rpx"></el-table-column>
                <el-table-column prop="proofImageUrl" label="提交凭证图片URL" align="center" width="160rpx">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="openPictureUrl(scope.row.proofImageUrl)" v-if="scope.row.proofImageUrl">点击查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="proofLink" label="提交凭证链接" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="copyTargetUrl(scope.row.proofLink)" v-if="scope.row.proofLink">点击跳转</el-button>
                        <!-- <span @click="copyTargetUrl(scope.row.proofLink)" class="cursor">{{ getHrefUrl(scope.row.proofLink) }}</span> -->
                    </template>
                </el-table-column>
                <el-table-column prop="taskStatus" label="任务状态" align="center" width="100px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskStatus===null"></span>
                        <span v-else-if="scope.row.taskStatus==-1">审核不通过</span>
                        <span v-else-if="scope.row.taskStatus==0">新任务</span>
                        <span v-else-if="scope.row.taskStatus==1">待完成</span>
                        <span v-else-if="scope.row.taskStatus==2">待审核</span>
                        <span v-else-if="scope.row.taskStatus==3">审核完成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failureReason" label="失败原因" align="center" width="240px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.failureReason">{{ scope.row.failureReason }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updatedAt" label="更新时间" align="center" width="100px"></el-table-column>
                <el-table-column prop="createdAt" label="创建时间" align="center" width="100px"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="120px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTip(scope.row)">审核</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        任务类型
                    </div>
                    <div class="value">
                        <el-select disabled v-model="formData.taskType" placeholder="请选择">
                            <el-option
                            v-for="item in taskTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        任务标题
                    </div>
                    <div class="value">
                        <el-input v-model="formData.title" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        任务描述
                    </div>
                    <div class="value">
                        <el-input v-model="formData.description" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        任务内容文案
                    </div>
                    <div class="value">
                        <el-input disabled v-model="formData.content" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                

                <div class="item" v-if="formData.mediaUrl&&formData.mediaUrl.length>0">
                    <div class="label">
                        素材上传
                    </div>
                    <!-- <div class="value">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="uploadImg"
                            >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div> -->
                </div>
                
                <div class="picList">
                    <div class="pic" v-for="(item,index) in formData.mediaUrl" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="item"
                        :preview-src-list="[item]"
                        :fit="cover"
                        ></el-image>
                        <!-- <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clear(index)"> -->
                    </div>
                </div>
                <div class="item" v-if="formData.taskType==2||formData.taskType==3">
                    <div class="label">
                        目标链接
                    </div>
                    <div class="value">
                        <el-input v-model="formData.targetUrl" disabled size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        文本素材
                    </div>
                    <div class="value">
                        <el-input v-model="formData.textMaterial" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        基础奖励金额
                    </div>
                    <div class="value">
                        <el-input v-model="formData.reward" disabled size="small" placeholder="请输入"></el-input>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        任务状态
                    </div>
                    <div class="value">
                        <el-select v-model="formData.taskStatus" placeholder="请选择">
                            <el-option
                            v-for="item in taskStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
               
                <div class="item" v-if="formData.proofImageUrl">
                    <div class="label">
                        提交凭证图片URL
                    </div>
                    <div class="value"></div>
                </div>
                
                <div class="picList" v-if="formData.proofImageUrl">
                    <div class="pic" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="formData.proofImageUrl"
                        :preview-src-list="[formData.proofImageUrl]"
                        :fit="cover"
                        ></el-image>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        提交凭证链接
                    </div>
                    <div class="value">
                        <el-input disabled v-model="formData.proofLink" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item" v-if="formData.taskStatus == -1">
                    <div class="label">
                        失败原因
                    </div>
                    <div class="value">
                        <el-input v-model="formData.failureReason" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        任务要求
                    </div>
                    <div class="value">
                        <el-input v-model="formData.requireMents" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        注意事项
                    </div>
                    <div class="value">
                        <el-input v-model="formData.notice" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="btns">
                    <el-button type="primary" @click="edit">确认</el-button>
                </div>
            </div>
        </el-dialog>

         <!-- 大图预览 -->
         <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],
            conditionData:{
                // 任务类型
                taskType:null,
                // 任务状态
                taskStatus:2,
                current:1,
                size:10,
            },
            queryList:[
                {type: "select",label: "任务类型:",name: "taskType",options:[{
                    label:'抖音视频',
                    value:1,
                },{
                    label:'抖音评论',
                    value:2,
                },{
                    label:'小红书',
                    value:3,
                },{
                    label:'应用好评',
                    value:4,
                },{
                    label:'快手视频',
                    value:5,
                },{
                    label:'快手评论',
                    value:6,
                },{
                    label:'小红书评论',
                    value:7,
                },{
                    label:'抖音图文',
                    value:8,
                }]},
                {type: "select",label: "任务状态:",name: "taskStatus",options:[{
                    label:'审核失败',
                    value:-1,
                },{
                    label:'审核中',
                    value:2,
                },{
                    label:'审核完成',
                    value:3,
                }]},
            ],
            taskTypeList:[{
                    label:'抖音视频',
                    value:1,
                },{
                    label:'抖音评论',
                    value:2,
                },{
                    label:'小红书',
                    value:3,
                },{
                    label:'应用好评',
                    value:4,
                },{
                    label:'快手视频',
                    value:5,
                },{
                    label:'快手评论',
                    value:6,
                },{
                    label:'小红书评论',
                    value:7,
                },{
                    label:'抖音图文',
                    value:8,
                }],
            taskStatusList:[{
                    label:'审核通过',
                    value:3,
                },{
                    label:'审核不通过',
                    value:-1,
                }
                // ,{
                //     label:'新任务',
                //     value:0,
                // },{
                //     label:'待完成',
                //     value:1,
                // },{
                //     label:'审核中',
                //     value:2,
                // }
            ],
            formData:{
                id:null,
                taskType:'',
                appStoreTitle:'',
                content:'',
                mediaUrl:[],
                reward:null,
                taskStatus:0,
                userId:null,
                proofImageUrl:'',
                proofLink:'',
                failureReason:'',
            },
            formList:[
                {type: "input",label: "任务类型:",name: "taskType"},
                {type: "input",label: "任务标题:",name: "title"},
                {type: "input",label: "任务描述:",name: "description"},
                {type: "input",label: "任务内容文案:",name: "content",},
                {type: "input",label: "媒体文件URL数组:",name: "mediaUrlList"},
                {type: "input",label: "媒体文件URL:",name: "mediaUrl"},
                {type: "input",label: "目标链接:",name: "targetUrl"},
                {type: "input",label: "文本素材:",name: "textMaterial"},
                {type: "input",label: "基础奖励金额:",name: "reward"},



                {type: "input",label: "任务状态:",name: "taskStatus"},
                {type: "input",label: "接收任务用户:",name: "userId"},
                {type: "input",label: "提交凭证图片:",name: "proofImageUrl"},
                {type: "input",label: "提交凭证:",name: "proofLink"},
            ],
            // 提交规则
            formRules:{
               
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        closeViewer(){
            this.showBigImg = false;
        },
        openPictureUrl(url){
            if (url) {
                this.showBigImgList = [url];
                this.showBigImg = true;
            }
        },
        copyTargetUrl(url){
            if (url) {
                window.open(this.getHrefUrl(url), '_blank');
            }
        },
        getHrefUrl(text){
            if (!text) return '';
            const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
            const urls = text.match(urlRegex);
            return urls && urls.length > 0 ? urls[0] : '';
        },
        clear(index){
            this.formData.mediaUrl.splice(index,1)
        },
        async uploadImg(file){
            let res= await api.uploadFile(file.file);
            this.formData.mediaUrlList.push(res);
        },
        showImg(url){
            this.showBigImgList = [url];
            this.showBigImg = true;
        },
        addDialogShow(){
            this.isAddDialog = true;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.getShenHeTaskPage({
                current:this.conditionData.current,
                size:this.conditionData.size,
                taskType:this.conditionData.taskType,
                taskStatus:this.conditionData.taskStatus,
            });
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                taskType:null,
                taskStatus:2,
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        // 新增弹窗
        showAddDialog(e){
            this.isAddDialog = true;
        },
        // 新增方法
        async add(){
            
            let res  = await api.saveTask(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.$refs["formListAdd"].resetFields();
                this.isAddDialog = false;
                this.loadingData();
            }
        },
        
        // 编辑方法
        async edit(){
            let res = await api.updateTask(this.formData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.isUpdateDialog = false;
                this.loadingData();
                this.formData = {
                    id:null,
                    taskType:'',
                    appStoreTitle:'',
                    content:'',
                    mediaUrl:[],
                    reward:null,
                    taskStatus:'',
                    userId:null,
                    proofImageUrl:'',
                    proofLink:'',
                    failureReason:'',
                }
            }
        },
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }
        },
        // 删除提示
        deleteRowTip(row){
            this.$confirm('将删除委托主体——'+row.name+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRow(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除方法
        async deleteRow(row){
            let res  = await api.AgentDeleteAgent({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },


        editTip(item){
            this.isUpdateDialog = true;
            this.formData = item;
            this.formData.taskStatus = null
            this.$forceUpdate();
        },
        async edit(){
            let res = await api.updateTask(this.formData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.isUpdateDialog = false;
                this.loadingData();
                this.formData = {
                    id:null,
                    userId:'',
                    phone:'',
                    logo:'',
                    agentName:'',
                    custName:'', 
                    loginWel:'',
                    yongJinRatio:'',
                    yaoQingUrl:'',  
                }
            }
        },


        deleteTip(item){
            this.$confirm('将删除此代理?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(item){
            let res = await api.AgentDeleteAgent(item.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                display: flex;
                width: 400px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            margin:0 10px;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: -10px;
                    right: -10px;
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            justify-content: center;
            .el-button{
                margin-right: 10px;
            }
        }
    }
    :deep(.el-input.is-disabled .el-input__inner){
        color: #222222;
    }
    :deep(.el-textarea.is-disabled .el-textarea__inner){
        color: #222222;
    }
    .cursor{
        cursor: pointer;
    }
</style>
